import { useEffect, useState } from 'react';
import { ESRIMapProps, GoogleMapProps, Location } from '../types';

type MapProps = ESRIMapProps | GoogleMapProps | undefined;

const useLocationPicker = (map: MapProps) => {
  const [location, setLocation] = useState<Location | undefined>(undefined);

  /**
   * Register on-click callback and update location when the user clicks on the map
   */
  useEffect(() => {
    if (!map) {
      throw new Error('Map not initialized on window');
    }

    const handleESRIMapClick = (event: __esri.ViewClickEvent) => {
      setLocation({
        latitude: event.mapPoint.latitude,
        longitude: event.mapPoint.longitude,
      });
    };

    const handleGoogleMapClick = (event: google.maps.MapMouseEvent) => {
      if (!event.latLng) {
        throw new Error('Could not get latlng from Google map click');
      }

      setLocation({
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng(),
      });
    };

    let listener:
      | google.maps.MapsEventListener
      | __esri.WatchHandle
      | undefined;

    if (map.mapProvider === 'esri') {
      listener = map.mapInstance.view?.on('click', handleESRIMapClick);
    } else if (map.mapProvider === 'google') {
      listener = map.mapInstance.addListener('click', handleGoogleMapClick);
    }

    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, [map]);

  return location;
};

export default useLocationPicker;
